import React from "react";
import { motion } from "framer-motion";

import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import BrandPillars from "../components/BrandPillars";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import BrandPartners from "../components/BrandPartners";
import Industries from "../components/Industries";
import EnergyBanner from "../components/EnergyBanner";
import CTASection from "../components/CTASection";

/**
 * Smooth scroll reveal optimized for mobile
 */
function ScrollReveal({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{
        once: true,
        amount: 0.2,
      }}
      transition={{
        duration: 0.5,
        ease: "easeOut",
        delay,
      }}
    >
      {children}
    </motion.div>
  );
}

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      {/* HERO (no scroll animation) */}
      <Hero />

      <ScrollReveal delay={0}>
        <AboutUs />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <BrandPillars />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <Services />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <WhyChooseUs />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <BrandPartners />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <Industries />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <EnergyBanner />
      </ScrollReveal>

      <ScrollReveal delay={0.05}>
        <CTASection />
      </ScrollReveal>
    </motion.div>
  );
}